// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scope-select[data-v-4375d670],\n.scope-select .el-select[data-v-4375d670] {\n  width: 100%;\n}\n.select-scope-default[data-v-4375d670]{\n  width: 230px;\n  margin: 0 10px 24px 0;\n}\n.search-english[data-v-4375d670]{\n  width: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
